import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import editbutton from "../static/images/edit-button.svg";
import $ from "jquery";
import xbutton from "../static/images/X_icon.png";

const Contrato = ({ data, edit }) => {
  const [loading, setLoading] = useState(true);
  const [listUserContract, setlistUserContract] = useState([]);
  const [listContracts, setlistContracts] = useState([]);
  const [delContrato, setdelContrato] = useState("");
  const [show, setShow] = useState(false);
  // const [showEditar, setShowEditar] = useState(false);

  const handleClose = () => setShow(false);

  useEffect(() => {
    if (data === undefined) {
      setLoading(true);
    } else {
      GetContratos();
    }
  }, [data]);

  useEffect(() => {
    if (data === undefined) {
      setLoading(true);
    } else {
      ListContratos();
    }
  }, [listUserContract]);

  function ConvertArray(list) {
    let array = [];
    let flag = true;
    list.map((item) => {
      if (!listUserContract.find((i) => i.contractId === item.contractId)) {
        if (flag) {
          let op = {
            value: item.contractId,
            name: item.name,
          };
          op.value = "hidden";
          flag = false;
          array.push(op);
        }
        let op = {
          value: item.contractId,
          name: item.name,
        };
        array.push(op);
      }
    });
    setlistContracts(array);
    setLoading(false);
  }

  function GetContratos() {
    axios.get("contract/list-contract-applicant/" + data).then((result) => {
      setlistUserContract(result.data);
    });
  }

  function ListContratos() {
    axios.get("contract/list-contracts").then((result) => {
      ConvertArray(result.data);
      setLoading(false);
    });
  }

  function GuardarContrato(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    let contrato = {
      applicantContractId: values.contractId,
      applicantId: data,
      contractId: values.contractId,
      //description: values.description,
      description: "",
    };

    axios
      .post(
        "contract/create-applicantcontract",
        JSON.stringify(contrato),
        config
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetContratos();
          $("#agregar-contrato-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#agregar-contrato-modal").modal("hide");
      });
  }
  function EditarContrato(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    let contrato = {
      applicantContractId: values.applicantContractId,
      applicantId: values.applicantId,
      contractId: values.contractEditId,
      description: values.description,
    };
    axios
      .post("contract/update-applicantcontract", contrato)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetContratos();
          $("#editar-contrato-modal").modal("hide");
          //setShowEditar(false);
        }
      })
      .catch(function (error) {
        $("#editar-contrato-modal").modal("hide");
      });
  }
  function FindContrato(id) {
    setdelContrato(listUserContract.find((i) => i.contractId === id));
  }
  function DeleteContrato() {
    const exp = {
      applicantContractId: delContrato.applicantContractId,
      contractId: delContrato.contractId,
      description: delContrato.description,
    };
    axios
      .post("contract/delete-applicantcontract", exp)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          //const mod = new Modal(document.getElementById("eliminar-contrato-modal"));
          //mod.hide();
          setShow(false);
          //setShowEditar(false);
          GetContratos();
          $("#editar-contrato-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#editar-contrato-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    contractId: Yup.string().required("No puede estar vacio"),
  });
  
  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <div className="box right-col">
          <div className="head">
            <div className="title">Tipos de Aplicación</div>
            {edit && edit ? 
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#agregar-contrato-modal"
              >
                <img src={editbutton} alt="Agregar Ultimas Publicaciones"></img>
              </a>
             : 
              null
            }
          </div>

          <div className="tags-cloud">
            <div className="tags-cloud__wrapper">
              {listUserContract.map((item, index) => {
                return (
                  <div key={index} className="tag">
                    {edit ? <span
                      className="cierre-X"
                      onClick={() => FindContrato(item.contractId)}
                      data-bs-toggle="modal"
                      data-bs-target="#editar-contrato-modal"
                    >
                      <img src={xbutton} style={{ width: "20px" }}></img>
                    </span>: null}
                    {item.description}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <div
        id="agregar-contrato-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Formik
                initialValues={{
                  applicantContractId: 0,
                  applicantId: data,
                  contractId: 0,
                  description: "",
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  GuardarContrato(values);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="contractId" className="col-sm-2 pe-0">
                        Tipos de Aplicación
                      </label>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="contractId"
                          id="contractId"
                          required
                          className="form-select form-select-sm"
                        >
                          <option hidden selected>
                            Seleccione un tipo
                          </option>
                          {listContracts.map((item, index) => {
                            if (item.value === "hidden") {
                              return (
                                <option key={index} hidden>
                                  Seleccione un tipo
                                </option>
                              );
                            } else {
                              return (
                                <option key={index} value={item.value}>
                                  {item.name}
                                </option>
                              );
                            }

                            // return (
                            //   <option key={index} value={item.value}>
                            //     {item.name}
                            //   </option>
                            // );
                          })}
                        </Field>
                        {errors.contractId && touched.contractId && (
                          <span className="form__validation form__validation--error">
                            {errors.contractId}
                          </span>
                        )}
                      </div>
                    </div>
                    {/*
                        <div className="mb-4 row">
                          <label htmlFor="cargo" className="col-sm-2 pe-0">
                            Descripcion
                          </label>
                          <div className="col-sm-10">
                            <Field
                              as="textarea"
                              id="description"
                              name="description"
                              type="text"
                              required
                              className="form-control form-control-sm"
                            ></Field>
                            {errors.description && touched.description && (
                              <span className="form__validation form__validation--error">
                                {errors.description}
                              </span>
                            )}
                          </div>
                        </div>
                        */}
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--small btn--purple"
                      >
                        <i className="fas fa-paper-plane"></i>Aceptar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      <div
        id="editar-contrato-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white ">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Actualizar esta Aplicación
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          applicantContractId: delContrato.applicantContractId,
                          applicantId: data,
                          contractEditId: delContrato.contractId,
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                          setSubmitting(true);
                          EditarContrato(values);
                          setSubmitting(false);
                        }}
                      >
                        <Form>
                          <Field
                            as="select"
                            name="contractEditId"
                            id="contractEditId"
                            required
                          >
                            {listContracts.map((item, index) => {
                              if (item.value === "hidden") {
                                return (
                                  <option key={index} hidden>
                                    Seleccione un tipo
                                  </option>
                                );
                              } else {
                                return (
                                  <option key={index} value={item.value}>
                                    {item.name}
                                  </option>
                                );
                              }
                            })}
                          </Field>
                          <div className="form__row">
                            <button
                              //disabled={isSubmitting}
                              type="submit"
                              className="btn btn--gradient btn__icon btn__icon--door"
                            >
                              <i className="fas fa-paper-plane"></i>Aceptar
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => setShow(true)}
                            >
                              Eliminar
                            </button>
                          </div>
                        </Form>
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        keyboard={false}
        onHide={handleClose}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__title text-center">
                Eliminar Tipo de Aplicacion
              </div>
              <div className="form__row">
                <div className="col-sm-12 ">
                  <label htmlFor="names">Desea eliminar este registro?</label>
                </div>
              </div>
              <div className="form__row">
                <button
                  className="btn btn--gradient btn__icon btn__icon--door"
                  onClick={() => DeleteContrato()}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default Contrato;
